
import IconButton from "../../../items/iconButton";
import volumeButton from "../../../items/volumeButton";
import directionButton from "../../../items/directionButton";
import topTips from "../../../items/topTips";
import actionButton from "../../../items/actionButton";
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { windVane } from "../../../utils/tmallGenius";
import { RemoteParams } from "../../../utils/device/set/remote";
import { getRemoteIdList, getIrs } from "../../../api/kookong.js";
import { sendCmd, addSubDevice, updateDevInfo } from "../../../api/index.js";

export default {
components: {
IconButton, //图标
Flexbox,
FlexboxItem,
volumeButton,
directionButton,
topTips,
actionButton,
Loading
},
created() {
this.getList()
.then(res => {
const val = res.join(",");

return this.getIr(val);
})
.then(res => {
this.isLoading = false;
this.irDataList = res;
this.irDataList && this.setRid();
});
},
data() {
return {
irDataList: [],
isLoading: false,
currentNum: 0,
currentRid: {
1: "",
9367: "",
9362: "",
9372: "",
31: "",
1105: "",
1762: "",
rid: ""
}
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("风扇遥控器");
next();
},
methods: {
/**@name 发送命令
*
*/
onClick: function(val) {
const data = {
token: sessionStorage.getItem("token"),
cmd: "15",
uid: this.$route.query.uid,
deviceId: this.$route.query.deviceId, // 小方配置遥控器添加“1”
order: "ir control",
value1: 0,
value2: 0,
value3: 0,
value4: 0,
freq: this.currentRid.freq,
pluseNum: val.split(",").length,
pluseData: val
};
sendCmd(data).then(res => {});
},
next: function(val) {
this.currentNum = val - 1;
this.setRid();
},
pre: function(val) {
this.currentNum = val - 1;
this.setRid();
},
/**@name 绑定确定当前遥控器
*/
current: function() {
const remoteParams = new RemoteParams();
remoteParams.brandId = this.$route.query.bid;
const data = {
token: sessionStorage.getItem("token"),
uid: this.$route.query.uid,
deviceType: this.$route.query.deviceType,
deviceName: "风扇遥控器",
roomId: "",
rid: this.currentRid.rid,
company: remoteParams.transToString()
};
addSubDevice(data)
.then(res => {
if (res.status === 0) {
this.toast_success();
let device = res.data;

updateDevInfo({

m: "updateZone",
token: sessionStorage.getItem("token"),
deviceId: device.deviceId,
zone: this.$route.query.aligenieZone
});
setTimeout(() => {
this.$router.replace("/device/xiaofang/tips?deviceName=fan&deviceId=" + device.deviceId);
}, 2000);
} else {
this.toast_fail();
}
})
.catch(res => {
this.toast_fail();
});
},
toTutorial: function() {
this.$router.push("/tutorial");
},
setRid() {
const data = this.irDataList[this.currentNum];
if (!data) {
return;
}
for (let key in this.currentRid) {
data.keys.map(item => {
if (item.fid == key) {
this.currentRid[key] = item.pulse;
}
});
this.currentRid.rid = data.rid;
this.currentRid.freq = data.frequency;
}
},
getList() {
const data = {
deviceType: this.$route.query.kookongDeviceType,
brandId: this.$route.query.bid
};
this.isLoading = true;
return getRemoteIdList(data).then(res => {
return res.data;
});
},
async getIr(val) {
const list = [];
if (val.length > 50) {
const data = {
rids: val.slice(0, 50)
};
const beferKeys = await this.getKeys({ rids: val.slice(0, 50) });
const afertKeys = await this.getKeys({ rids: val.slice(50, val.length) });
return beferKeys.concat(afertKeys);
} else {
return getIrs({ rids: val }).then(res => {
return res.data;
});
}
},
getKeys(data) {
return getIrs(data).then(res => {
return res.data;
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/fan/Index.vue